import React from 'react'
import { GA_TRACKING_ID, ENV } from '../../config'

// Google Analytics 
import ReactGA from 'react-ga';
ReactGA.initialize(ENV === 'production' ? GA_TRACKING_ID : "UA-152397584-3");

//App.js 
export const identify = (userId, props) => {
    // window.analytics.identify(userId, {
    //     name: props.user.firstName + " " + props.user.lastName,
    //     email: props.user.email,
    //     organizationName: props.user.organizationName,
    //     phone: props.user.phone,
    //     role: props.user.role
    // });
};

export const trackEvent = (eventName, props) => {
    ReactGA.event({
        action:eventName,
        category:props.category,
        label:props.label
    })
    // window.analytics.track(event, props);
};

export const trackWithValue = (eventName, props) => {
    ReactGA.event({
        action:eventName,
        category:props.category,
        label:props.label,
        value:props.value
    })
    // window.analytics.track(event, props);
};

export const trackPageView = (url) => {
    ReactGA.pageview(url);
}